import { DietaryRestriction } from '@sg/graphql-schema';

import { type DietaryPreferencesTypes } from './types';

// ─────────────────────────────────────────────────────────────────────────────

export function generateInitialContext(): Context {
  return {
    preferences: INITIAL_DIETARY_PREFERENCES,
    pendingPreferences: INITIAL_DIETARY_PREFERENCES,
    activateAfterFetch: false,
    stayActiveAfterConfirm: false,
  };
}

// ─── Constants ───────────────────────────────────────────────────────────────

export const INITIAL_DIETARY_PREFERENCES: DietaryPreferencesTypes = {
  [DietaryRestriction.Dairy]: false,
  [DietaryRestriction.Meat]: false,
  [DietaryRestriction.Nuts]: false,
  [DietaryRestriction.Gluten]: false,
  [DietaryRestriction.Fish]: false,
  [DietaryRestriction.Soy]: false,
};

// ─── Types ───────────────────────────────────────────────────────────────────

export type Context = {
  preferences: DietaryPreferencesTypes;
  pendingPreferences: DietaryPreferencesTypes;
  activateAfterFetch: boolean;
  stayActiveAfterConfirm: boolean;
};
